/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */
/* eslint-disable array-callback-return */
import { TableCell, TableRow } from "@mui/material";
import React from "react";
import Table from "../Table";
import tableStyle from "../../../../theme/styles/table";
import styles from "./ReportsTable.styles";
import Typography from "../../../../components/common/new/Typography/Typography";

const tabelCellWidth = {
  tiny: {
    maxWidth: "3.5rem",
  },
  small: {
    maxWidth: "6rem",
  },
  medium: {
    maxWidth: "10rem",
  },
};

// const BLOCK = "BLOCK";
// const CHAPTER = "CHAPTER";
// const DISTRICT = "DISTRICT";
// const REGION = "REGION";
// const ZONE = "ZONE";

const getRows = ({ searchData }) => {
  const rows = [];

  const grandTotal = {
    totalGohonzon: 0,
    memberMdCount: 0,
    memberWdCount: 0,
    memberYmdCount: 0,
    memberYwdCount: 0,
    memberYmdSdCount: 0,
    memberYwdSdCount: 0,
    memberFdbCbCount: 0,
    memberFdbYlbCount: 0,
    memberFdbYpbCount: 0,
    memberFdgCgCount: 0,
    memberFdgYlgCount: 0,
    memberFdgYpgCount: 0,
    // memberYmdSdCount: 0,
    // memberYwdSdCount: 0,
    totalMemberCount: 0,
    friendMdCount: 0,
    friendWdCount: 0,
    friendYmdCount: 0,
    friendYwdCount: 0,
    friendYmdSdCount: 0,
    friendYwdSdCount: 0,
    friendFdbCbCount: 0,
    friendFdbYpbCount: 0,
    friendFdbYlbCount: 0,
    friendFdgCgCount: 0,
    friendFdgYpgCount: 0,
    friendFdgYlgCount: 0,
    totalFriendCount: 0,
    zoneCount: 0,
    regionCount: 0,
    chapterCount: 0,
    districtCount: 0,
    blockCount: 0,
    nationalChiefCount: 0,
    nationalDeputyChiefCount: 0,
    nationalAdvisorCount: 0,
    areaChiefCount: 0,
    areaDeputyChiefCount: 0,
    areaAdvisorCount: 0,
    areaViceChiefCount: 0,
    zoneChiefCount: 0,
    zoneDeputyChiefCount: 0,
    zoneAdvisorCount: 0,
    zoneViceChiefCount: 0,
    regionChiefCount: 0,
    regionDeputyChiefCount: 0,
    regionAdvisorCount: 0,
    regionViceChiefCount: 0,
    chapterChiefCount: 0,
    chapterDeputyChiefCount: 0,
    chapterAdvisorCount: 0,
    chapterViceChiefCount: 0,
    districtChiefCount: 0,
    districtDeputyChiefCount: 0,
    districtAdvisorCount: 0,
    districtViceChiefCount: 0,
    blockChiefCount: 0,
    blockDeputyChiefCount: 0,
    blockAdvisorCount: 0,
    blockViceChiefCount: 0,
    totalLeaderCount: 0,
  };
  searchData.map((report, index) => {
    const {
      totalGohonzon,
      memberMdCount,
      memberWdCount,
      memberYmdCount,
      memberYwdCount,
      // memberYmdSdCount,
      // memberYwdSdCount,
      memberFdbCbCount,
      memberFdbYlbCount,
      memberFdbYpbCount,
      memberFdgCgCount,
      memberFdgYlgCount,
      memberFdgYpgCount,
      memberYmdSdCount,
      memberYwdSdCount,
      totalMemberCount,
      friendMdCount,
      friendWdCount,
      friendYmdCount,
      friendYwdCount,
      friendYmdSdCount,
      friendYwdSdCount,
      friendFdbCbCount,
      friendFdbYpbCount,
      friendFdbYlbCount,
      friendFdgCgCount,
      friendFdgYpgCount,
      friendFdgYlgCount,
      totalFriendCount,
      zoneCount,
      regionCount,
      chapterCount,
      districtCount,
      blockCount,
      nationalChiefCount,
      nationalDeputyChiefCount,
      nationalAdvisorCount,
      areaChiefCount,
      areaDeputyChiefCount,
      areaAdvisorCount,
      areaViceChiefCount,
      zoneChiefCount,
      zoneDeputyChiefCount,
      zoneAdvisorCount,
      zoneViceChiefCount,
      regionChiefCount,
      regionDeputyChiefCount,
      regionAdvisorCount,
      regionViceChiefCount,
      chapterChiefCount,
      chapterDeputyChiefCount,
      chapterAdvisorCount,
      chapterViceChiefCount,
      districtChiefCount,
      districtDeputyChiefCount,
      districtAdvisorCount,
      districtViceChiefCount,
      blockChiefCount,
      blockDeputyChiefCount,
      blockAdvisorCount,
      blockViceChiefCount,
      totalLeaderCount,
    } = report;

    grandTotal.totalGohonzon += totalGohonzon;
    grandTotal.memberMdCount += memberMdCount;
    grandTotal.memberWdCount += memberWdCount;
    grandTotal.memberYmdCount += memberYmdCount;
    grandTotal.memberYwdCount += memberYwdCount;
    grandTotal.memberYmdSdCount += memberYmdSdCount;
    grandTotal.memberYwdSdCount += memberYwdSdCount;
    grandTotal.memberFdbCbCount += memberFdbCbCount;
    grandTotal.memberFdbYlbCount += memberFdbYlbCount;
    grandTotal.memberFdbYpbCount += memberFdbYpbCount;
    grandTotal.memberFdgCgCount += memberFdgCgCount;
    grandTotal.memberFdgYlgCount += memberFdgYlgCount;
    grandTotal.memberFdgYpgCount += memberFdgYpgCount;
    // OLD (bug): YMDSD / YWDSD were getting added twice because UI was rendering these
    // columns two times (YMDSD/YWDSD + YmdSdCount/YwdSdCount). Keeping this commented
    // for future reference.
    // grandTotal.memberYmdSdCount += memberYmdSdCount;
    // grandTotal.memberYwdSdCount += memberYwdSdCount;
    grandTotal.totalMemberCount += totalMemberCount;
    grandTotal.friendMdCount += friendMdCount;
    grandTotal.friendWdCount += friendWdCount;
    grandTotal.friendYmdCount += friendYmdCount;
    grandTotal.friendYwdCount += friendYwdCount;
    grandTotal.friendYmdSdCount += friendYmdSdCount;
    grandTotal.friendYwdSdCount += friendYwdSdCount;
    grandTotal.friendFdbCbCount += friendFdbCbCount;
    grandTotal.friendFdbYpbCount += friendFdbYpbCount;
    grandTotal.friendFdbYlbCount += friendFdbYlbCount;
    grandTotal.friendFdgCgCount += friendFdgCgCount;
    grandTotal.friendFdgYpgCount += friendFdgYpgCount;
    grandTotal.friendFdgYlgCount += friendFdgYlgCount;
    grandTotal.totalFriendCount += totalFriendCount;
    grandTotal.zoneCount += zoneCount;
    grandTotal.regionCount += regionCount;
    grandTotal.chapterCount += chapterCount;
    grandTotal.districtCount += districtCount;
    grandTotal.blockCount += blockCount;
    grandTotal.nationalChiefCount += nationalChiefCount;
    grandTotal.nationalDeputyChiefCount += nationalDeputyChiefCount;
    grandTotal.nationalAdvisorCount += nationalAdvisorCount;
    grandTotal.areaChiefCount += areaChiefCount;
    grandTotal.areaDeputyChiefCount += areaDeputyChiefCount;
    grandTotal.areaAdvisorCount += areaAdvisorCount;
    grandTotal.areaViceChiefCount += areaViceChiefCount;
    grandTotal.zoneChiefCount += zoneChiefCount;
    grandTotal.zoneDeputyChiefCount += zoneDeputyChiefCount;
    grandTotal.zoneAdvisorCount += zoneAdvisorCount;
    grandTotal.zoneViceChiefCount += zoneViceChiefCount;
    grandTotal.regionChiefCount += regionChiefCount;
    grandTotal.regionDeputyChiefCount += regionDeputyChiefCount;
    grandTotal.regionAdvisorCount += regionAdvisorCount;
    grandTotal.regionViceChiefCount += regionViceChiefCount;
    grandTotal.chapterChiefCount += chapterChiefCount;
    grandTotal.chapterDeputyChiefCount += chapterDeputyChiefCount;
    grandTotal.chapterAdvisorCount += chapterAdvisorCount;
    grandTotal.chapterViceChiefCount += chapterViceChiefCount;
    grandTotal.districtChiefCount += districtChiefCount;
    grandTotal.districtDeputyChiefCount += districtDeputyChiefCount;
    grandTotal.districtAdvisorCount += districtAdvisorCount;
    grandTotal.districtViceChiefCount += districtViceChiefCount;
    grandTotal.blockChiefCount += blockChiefCount;
    grandTotal.blockDeputyChiefCount += blockDeputyChiefCount;
    grandTotal.blockAdvisorCount += blockAdvisorCount;
    grandTotal.blockViceChiefCount += blockViceChiefCount;
    grandTotal.totalLeaderCount += totalLeaderCount;

    rows.push(
      <TableRow style={tableStyle.tableRow}>
        <TableCell style={tabelCellWidth.medium}>
          {" "}
          <Typography style={styles.typoghrphyStyle}>
            {index + 1}
          </Typography>{" "}
        </TableCell>
        <TableCell style={tabelCellWidth.medium}>
          {" "}
          <Typography style={styles.typoghrphyStyle}>
            {report?.structureName || "NA"}
          </Typography>{" "}
        </TableCell>
        <TableCell style={tabelCellWidth.medium}>
          <Typography style={styles.typoghrphyStyle}>
            {report?.totalGohonzon ?? "NA"}
          </Typography>{" "}
        </TableCell>
        <TableCell style={tabelCellWidth.small}>
          <div style={styles.tableBox}>
            <Typography style={styles.typoghrphyStyle}>
              {report?.memberMdCount ?? "NA"}
            </Typography>
          </div>
        </TableCell>
        <TableCell style={tabelCellWidth.small}>
          <div style={styles.tableBox}>
            <Typography style={styles.typoghrphyStyle}>
              {report?.memberWdCount ?? "NA"}
            </Typography>
          </div>
        </TableCell>
        <TableCell>
          <div>
            <Typography style={styles.typoghrphyStyle}>
              {report?.memberYmdCount ?? "NA"}
            </Typography>{" "}
          </div>
        </TableCell>
        <TableCell>
          <div>
            <Typography style={styles.typoghrphyStyle}>
              {report?.memberYwdCount ?? "NA"}
            </Typography>{" "}
          </div>
        </TableCell>
        {/* NEW: memberYmdSdCount and memberYwdSdCount columns added */}
        <TableCell>
          <div>
            <Typography style={styles.typoghrphyStyle}>
              {report?.memberYmdSdCount ?? "NA"}
            </Typography>{" "}
          </div>
        </TableCell>
        <TableCell>
          <div>
            <Typography style={styles.typoghrphyStyle}>
              {report?.memberYwdSdCount ?? "NA"}
            </Typography>{" "}
          </div>
        </TableCell>
        <TableCell>
          <div>
            <Typography style={styles.typoghrphyStyle}>
              {report?.memberFdbCbCount ?? "NA"}
            </Typography>{" "}
          </div>
        </TableCell>
        <TableCell>
          <div>
            <Typography style={styles.typoghrphyStyle}>
              {report?.memberFdbYlbCount ?? "NA"}
            </Typography>{" "}
          </div>
        </TableCell>
        <TableCell>
          <div>
            <Typography style={styles.typoghrphyStyle}>
              {report?.memberFdbYpbCount ?? "NA"}
            </Typography>{" "}
          </div>
        </TableCell>
        <TableCell>
          <div>
            <Typography style={styles.typoghrphyStyle}>
              {report?.memberFdgCgCount ?? "NA"}
            </Typography>{" "}
          </div>
        </TableCell>
        <TableCell>
          <div>
            <Typography style={styles.typoghrphyStyle}>
              {report?.memberFdgYlgCount ?? "NA"}
            </Typography>{" "}
          </div>
        </TableCell>
        <TableCell>
          <div>
            <Typography style={styles.typoghrphyStyle}>
              {report?.memberFdgYpgCount ?? "NA"}
            </Typography>{" "}
          </div>
        </TableCell>
        {/* OLD (bug): Duplicate YMDSD/YWDSD columns. */}
        {/* <TableCell>
          <div>
            <Typography style={styles.typoghrphyStyle}>
              {report?.memberYmdSdCount ?? "NA"}
            </Typography>{" "}
          </div>
        </TableCell>
        <TableCell>
          <div>
            <Typography style={styles.typoghrphyStyle}>
              {report?.memberYwdSdCount ?? "NA"}
            </Typography>{" "}
          </div>
        </TableCell> */}
        <TableCell>
          <div>
            <Typography style={styles.typoghrphyStyle}>
              {report?.totalMemberCount ?? "NA"}
            </Typography>{" "}
          </div>
        </TableCell>
        <TableCell style={tabelCellWidth.small}>
          <div style={styles.tableBox}>
            <Typography style={styles.typoghrphyStyle}>
              {report?.friendMdCount ?? "NA"}
            </Typography>
          </div>
        </TableCell>
        <TableCell style={tabelCellWidth.small}>
          <div style={styles.tableBox}>
            <Typography style={styles.typoghrphyStyle}>
              {report?.friendWdCount ?? "NA"}
            </Typography>
          </div>
        </TableCell>
        <TableCell>
          <div>
            <Typography style={styles.typoghrphyStyle}>
              {report?.friendYmdCount ?? "NA"}
            </Typography>{" "}
          </div>
        </TableCell>
        <TableCell>
          <div>
            <Typography style={styles.typoghrphyStyle}>
              {report?.friendYwdCount ?? "NA"}
            </Typography>{" "}
          </div>
        </TableCell>
        <TableCell>
          <div>
            <Typography style={styles.typoghrphyStyle}>
              {report?.friendYmdSdCount ?? "NA"}
            </Typography>{" "}
          </div>
        </TableCell>
        <TableCell>
          <div>
            <Typography style={styles.typoghrphyStyle}>
              {report?.friendYwdSdCount ?? "NA"}
            </Typography>{" "}
          </div>
        </TableCell>
        <TableCell>
          <div>
            <Typography style={styles.typoghrphyStyle}>
              {report?.friendFdbCbCount ?? "NA"}
            </Typography>{" "}
          </div>
        </TableCell>
        <TableCell>
          <div>
            <Typography style={styles.typoghrphyStyle}>
              {report?.friendFdbYpbCount ?? "NA"}
            </Typography>{" "}
          </div>
        </TableCell>
        <TableCell>
          <div>
            <Typography style={styles.typoghrphyStyle}>
              {report?.friendFdbYlbCount ?? "NA"}
            </Typography>{" "}
          </div>
        </TableCell>
        <TableCell>
          <div>
            <Typography style={styles.typoghrphyStyle}>
              {report?.friendFdgCgCount ?? "NA"}
            </Typography>{" "}
          </div>
        </TableCell>
        <TableCell>
          <div>
            <Typography style={styles.typoghrphyStyle}>
              {report?.friendFdgYpgCount ?? "NA"}
            </Typography>{" "}
          </div>
        </TableCell>
        <TableCell>
          <div>
            <Typography style={styles.typoghrphyStyle}>
              {report?.friendFdgYlgCount ?? "NA"}
            </Typography>{" "}
          </div>
        </TableCell>
        <TableCell>
          <div>
            <Typography style={styles.typoghrphyStyle}>
              {report?.totalFriendCount ?? "NA"}
            </Typography>{" "}
          </div>
        </TableCell>

        {/* {report.hierarchy !== ZONE &&
          report.hierarchy !== REGION &&
          report.hierarchy !== CHAPTER &&
          report.hierarchy !== DISTRICT &&
          report.hierarchy !== BLOCK && (
            <TableCell>
              <div>
                <Typography style={styles.typoghrphyStyle}>
                  {report?.zoneCount ?? "NA"}
                </Typography>{" "}
              </div>
            </TableCell>
          )}
        {report.hierarchy !== REGION &&
          report.hierarchy !== CHAPTER &&
          report.hierarchy !== DISTRICT &&
          report.hierarchy !== BLOCK && (
            <TableCell>
              <div>
                <Typography style={styles.typoghrphyStyle}>
                  {report?.regionCount ?? "NA"}
                </Typography>{" "}
              </div>
            </TableCell>
          )}
        {report.hierarchy !== CHAPTER &&
          report.hierarchy !== DISTRICT &&
          report.hierarchy !== BLOCK && (
            <TableCell>
              <div>
                <Typography style={styles.typoghrphyStyle}>
                  {report?.chapterCount ?? "NA"}
                </Typography>{" "}
              </div>
            </TableCell>
          )}
        {report.hierarchy !== DISTRICT && report.hierarchy !== BLOCK && (
          <TableCell>
            <div>
              <Typography style={styles.typoghrphyStyle}>
                {report?.districtCount ?? "NA"}
              </Typography>{" "}
            </div>
          </TableCell>
        )}
        {report.hierarchy !== BLOCK && (
          <TableCell>
            <div>
              <Typography style={styles.typoghrphyStyle}>
                {report?.blockCount ?? "NA"}
              </Typography>{" "}
            </div>
          </TableCell>
        )} */}
        <TableCell>
          <div>
            <Typography style={styles.typoghrphyStyle}>
              {report?.nationalChiefCount ?? "NA"}
            </Typography>{" "}
          </div>
        </TableCell>
        <TableCell>
          <div>
            <Typography style={styles.typoghrphyStyle}>
              {report?.nationalDeputyChiefCount ?? "NA"}
            </Typography>{" "}
          </div>
        </TableCell>
        <TableCell>
          <div>
            <Typography style={styles.typoghrphyStyle}>
              {report?.nationalAdvisorCount ?? "NA"}
            </Typography>{" "}
          </div>
        </TableCell>
        <TableCell>
          <div>
            <Typography style={styles.typoghrphyStyle}>
              {report?.areaChiefCount ?? "NA"}
            </Typography>{" "}
          </div>
        </TableCell>
        <TableCell>
          <div>
            <Typography style={styles.typoghrphyStyle}>
              {report?.areaDeputyChiefCount ?? "NA"}
            </Typography>{" "}
          </div>
        </TableCell>
        <TableCell>
          <div>
            <Typography style={styles.typoghrphyStyle}>
              {report?.areaAdvisorCount ?? "NA"}
            </Typography>{" "}
          </div>
        </TableCell>
        <TableCell>
          <div>
            <Typography style={styles.typoghrphyStyle}>
              {report?.areaViceChiefCount ?? "NA"}
            </Typography>{" "}
          </div>
        </TableCell>
        <TableCell>
          <div>
            <Typography style={styles.typoghrphyStyle}>
              {report?.zoneChiefCount ?? "NA"}
            </Typography>{" "}
          </div>
        </TableCell>
        <TableCell>
          <div>
            <Typography style={styles.typoghrphyStyle}>
              {report?.zoneDeputyChiefCount ?? "NA"}
            </Typography>{" "}
          </div>
        </TableCell>
        <TableCell>
          <div>
            <Typography style={styles.typoghrphyStyle}>
              {report?.zoneAdvisorCount ?? "NA"}
            </Typography>{" "}
          </div>
        </TableCell>
        <TableCell>
          <div>
            <Typography style={styles.typoghrphyStyle}>
              {report?.zoneViceChiefCount ?? "NA"}
            </Typography>{" "}
          </div>
        </TableCell>
        <TableCell>
          <div>
            <Typography style={styles.typoghrphyStyle}>
              {report?.regionChiefCount ?? "NA"}
            </Typography>{" "}
          </div>
        </TableCell>
        <TableCell>
          <div>
            <Typography style={styles.typoghrphyStyle}>
              {report?.regionDeputyChiefCount ?? "NA"}
            </Typography>{" "}
          </div>
        </TableCell>
        <TableCell>
          <div>
            <Typography style={styles.typoghrphyStyle}>
              {report?.regionAdvisorCount ?? "NA"}
            </Typography>{" "}
          </div>
        </TableCell>
        <TableCell>
          <div>
            <Typography style={styles.typoghrphyStyle}>
              {report?.regionViceChiefCount ?? "NA"}
            </Typography>{" "}
          </div>
        </TableCell>
        <TableCell>
          <div>
            <Typography style={styles.typoghrphyStyle}>
              {report?.chapterChiefCount ?? "NA"}
            </Typography>{" "}
          </div>
        </TableCell>
        <TableCell>
          <div>
            <Typography style={styles.typoghrphyStyle}>
              {report?.chapterDeputyChiefCount ?? "NA"}
            </Typography>{" "}
          </div>
        </TableCell>
        <TableCell>
          <div>
            <Typography style={styles.typoghrphyStyle}>
              {report?.chapterAdvisorCount ?? "NA"}
            </Typography>{" "}
          </div>
        </TableCell>
        <TableCell>
          <div>
            <Typography style={styles.typoghrphyStyle}>
              {report?.chapterViceChiefCount ?? "NA"}
            </Typography>{" "}
          </div>
        </TableCell>
        <TableCell>
          <div>
            <Typography style={styles.typoghrphyStyle}>
              {report?.districtChiefCount ?? "NA"}
            </Typography>{" "}
          </div>
        </TableCell>
        <TableCell>
          <div>
            <Typography style={styles.typoghrphyStyle}>
              {report?.districtDeputyChiefCount ?? "NA"}
            </Typography>{" "}
          </div>
        </TableCell>
        <TableCell>
          <div>
            <Typography style={styles.typoghrphyStyle}>
              {report?.districtAdvisorCount ?? "NA"}
            </Typography>{" "}
          </div>
        </TableCell>
        <TableCell>
          <div>
            <Typography style={styles.typoghrphyStyle}>
              {report?.districtViceChiefCount ?? "NA"}
            </Typography>{" "}
          </div>
        </TableCell>
        <TableCell>
          <div>
            <Typography style={styles.typoghrphyStyle}>
              {report?.blockChiefCount ?? "NA"}
            </Typography>{" "}
          </div>
        </TableCell>
        <TableCell>
          <div>
            <Typography style={styles.typoghrphyStyle}>
              {report?.blockDeputyChiefCount ?? "NA"}
            </Typography>{" "}
          </div>
        </TableCell>
        <TableCell>
          <div>
            <Typography style={styles.typoghrphyStyle}>
              {report?.blockAdvisorCount ?? "NA"}
            </Typography>{" "}
          </div>
        </TableCell>
        <TableCell>
          <div>
            <Typography style={styles.typoghrphyStyle}>
              {report?.blockViceChiefCount ?? "NA"}
            </Typography>{" "}
          </div>
        </TableCell>
        <TableCell>
          <div>
            <Typography style={styles.typoghrphyStyle}>
              {report?.totalLeaderCount ?? "NA"}
            </Typography>{" "}
          </div>
        </TableCell>
      </TableRow>
    );
  });

  rows.push(
    <TableRow style={tableStyle.tableRow}>
      <TableCell style={tabelCellWidth.medium}>
        {" "}
        <Typography style={styles.typoghrphyStyle} />{" "}
      </TableCell>
      <TableCell style={tabelCellWidth.medium}>
        <Typography style={styles.typoghrphyStyle}>Total</Typography>
      </TableCell>
      <TableCell style={tabelCellWidth.medium}>
        <Typography style={styles.typoghrphyStyle}>
          {grandTotal?.totalGohonzon ?? "NA"}
        </Typography>{" "}
      </TableCell>
      <TableCell style={tabelCellWidth.small}>
        <div style={styles.tableBox}>
          <Typography style={styles.typoghrphyStyle}>
            {grandTotal?.memberMdCount ?? "NA"}
          </Typography>
        </div>
      </TableCell>
      <TableCell style={tabelCellWidth.small}>
        <div style={styles.tableBox}>
          <Typography style={styles.typoghrphyStyle}>
            {grandTotal?.memberWdCount ?? "NA"}
          </Typography>
        </div>
      </TableCell>
      <TableCell>
        <div>
          <Typography style={styles.typoghrphyStyle}>
            {grandTotal?.memberYmdCount ?? "NA"}
          </Typography>{" "}
        </div>
      </TableCell>
      <TableCell>
        <div>
          <Typography style={styles.typoghrphyStyle}>
            {grandTotal?.memberYwdCount ?? "NA"}
          </Typography>{" "}
        </div>
      </TableCell>
      {/* NEW: memberYmdSdCount and memberYwdSdCount total columns added */}
      <TableCell>
        <div>
          <Typography style={styles.typoghrphyStyle}>
            {grandTotal?.memberYmdSdCount ?? "NA"}
          </Typography>{" "}
        </div>
      </TableCell>
      <TableCell>
        <div>
          <Typography style={styles.typoghrphyStyle}>
            {grandTotal?.memberYwdSdCount ?? "NA"}
          </Typography>{" "}
        </div>
      </TableCell>
      <TableCell>
        <div>
          <Typography style={styles.typoghrphyStyle}>
            {grandTotal?.memberFdbCbCount ?? "NA"}
          </Typography>{" "}
        </div>
      </TableCell>
      <TableCell>
        <div>
          <Typography style={styles.typoghrphyStyle}>
            {grandTotal?.memberFdbYlbCount ?? "NA"}
          </Typography>{" "}
        </div>
      </TableCell>
      <TableCell>
        <div>
          <Typography style={styles.typoghrphyStyle}>
            {grandTotal?.memberFdbYpbCount ?? "NA"}
          </Typography>{" "}
        </div>
      </TableCell>
      <TableCell>
        <div>
          <Typography style={styles.typoghrphyStyle}>
            {grandTotal?.memberFdgCgCount ?? "NA"}
          </Typography>{" "}
        </div>
      </TableCell>
      <TableCell>
        <div>
          <Typography style={styles.typoghrphyStyle}>
            {grandTotal?.memberFdgYlgCount ?? "NA"}
          </Typography>{" "}
        </div>
      </TableCell>
      <TableCell>
        <div>
          <Typography style={styles.typoghrphyStyle}>
            {grandTotal?.memberFdgYpgCount ?? "NA"}
          </Typography>{" "}
        </div>
      </TableCell>
      {/* OLD (bug): Duplicate YMDSD/YWDSD cells in Total row caused two extra values (15,15)
          to appear near TOTAL MEMBER, shifting columns. Keeping this commented for reference. */}
      {/* <TableCell>
        <div>
          <Typography style={styles.typoghrphyStyle}>
            {grandTotal?.memberYmdSdCount ?? "NA"}
          </Typography>{" "}
        </div>
      </TableCell>
      <TableCell>
        <div>
          <Typography style={styles.typoghrphyStyle}>
            {grandTotal?.memberYwdSdCount ?? "NA"}
          </Typography>{" "}
        </div>
      </TableCell> */}
      <TableCell>
        <div>
          <Typography style={styles.typoghrphyStyle}>
            {grandTotal?.totalMemberCount ?? "NA"}
          </Typography>{" "}
        </div>
      </TableCell>
      <TableCell style={tabelCellWidth.small}>
        <div style={styles.tableBox}>
          <Typography style={styles.typoghrphyStyle}>
            {grandTotal?.friendMdCount ?? "NA"}
          </Typography>
        </div>
      </TableCell>
      <TableCell style={tabelCellWidth.small}>
        <div style={styles.tableBox}>
          <Typography style={styles.typoghrphyStyle}>
            {grandTotal?.friendWdCount ?? "NA"}
          </Typography>
        </div>
      </TableCell>
      <TableCell>
        <div>
          <Typography style={styles.typoghrphyStyle}>
            {grandTotal?.friendYmdCount ?? "NA"}
          </Typography>{" "}
        </div>
      </TableCell>
      <TableCell>
        <div>
          <Typography style={styles.typoghrphyStyle}>
            {grandTotal?.friendYwdCount ?? "NA"}
          </Typography>{" "}
        </div>
      </TableCell>
      <TableCell>
        <div>
          <Typography style={styles.typoghrphyStyle}>
            {grandTotal?.friendYmdSdCount ?? "NA"}
          </Typography>{" "}
        </div>
      </TableCell>
      <TableCell>
        <div>
          <Typography style={styles.typoghrphyStyle}>
            {grandTotal?.friendYwdSdCount ?? "NA"}
          </Typography>{" "}
        </div>
      </TableCell>
      <TableCell>
        <div>
          <Typography style={styles.typoghrphyStyle}>
            {grandTotal?.friendFdbCbCount ?? "NA"}
          </Typography>{" "}
        </div>
      </TableCell>
      <TableCell>
        <div>
          <Typography style={styles.typoghrphyStyle}>
            {grandTotal?.friendFdbYpbCount ?? "NA"}
          </Typography>{" "}
        </div>
      </TableCell>
      <TableCell>
        <div>
          <Typography style={styles.typoghrphyStyle}>
            {grandTotal?.friendFdbYlbCount ?? "NA"}
          </Typography>{" "}
        </div>
      </TableCell>
      <TableCell>
        <div>
          <Typography style={styles.typoghrphyStyle}>
            {grandTotal?.friendFdgCgCount ?? "NA"}
          </Typography>{" "}
        </div>
      </TableCell>
      <TableCell>
        <div>
          <Typography style={styles.typoghrphyStyle}>
            {grandTotal?.friendFdgYpgCount ?? "NA"}
          </Typography>{" "}
        </div>
      </TableCell>
      <TableCell>
        <div>
          <Typography style={styles.typoghrphyStyle}>
            {grandTotal?.friendFdgYlgCount ?? "NA"}
          </Typography>{" "}
        </div>
      </TableCell>
      <TableCell>
        <div>
          <Typography style={styles.typoghrphyStyle}>
            {grandTotal?.totalFriendCount ?? "NA"}
          </Typography>{" "}
        </div>
      </TableCell>

      {/* {searchData[0]?.hierarchy !== ZONE &&
        searchData[0]?.hierarchy !== REGION &&
        searchData[0]?.hierarchy !== CHAPTER &&
        searchData[0]?.hierarchy !== DISTRICT &&
        searchData[0]?.hierarchy !== BLOCK && (
          <TableCell>
            <div>
              <Typography style={styles.typoghrphyStyle}>
                {grandTotal?.zoneCount ?? "NA"}
              </Typography>{" "}
            </div>
          </TableCell>
        )}
      {searchData[0]?.hierarchy !== REGION &&
        searchData[0]?.hierarchy !== CHAPTER &&
        searchData[0]?.hierarchy !== DISTRICT &&
        searchData[0]?.hierarchy !== BLOCK && (
          <TableCell>
            <div>
              <Typography style={styles.typoghrphyStyle}>
                {grandTotal?.regionCount ?? "NA"}
              </Typography>{" "}
            </div>
          </TableCell>
        )}
      {searchData[0]?.hierarchy !== CHAPTER &&
        searchData[0]?.hierarchy !== DISTRICT &&
        searchData[0]?.hierarchy !== BLOCK && (
          <TableCell>
            <div>
              <Typography style={styles.typoghrphyStyle}>
                {grandTotal?.chapterCount ?? "NA"}
              </Typography>{" "}
            </div>
          </TableCell>
        )}
      {searchData[0]?.hierarchy !== DISTRICT &&
        searchData[0]?.hierarchy !== BLOCK && (
          <TableCell>
            <div>
              <Typography style={styles.typoghrphyStyle}>
                {grandTotal?.districtCount ?? "NA"}
              </Typography>{" "}
            </div>
          </TableCell>
        )}
      {searchData[0]?.hierarchy !== BLOCK && (
        <TableCell>
          <div>
            <Typography style={styles.typoghrphyStyle}>
              {grandTotal?.blockCount ?? "NA"}
            </Typography>{" "}
          </div>
        </TableCell>
      )} */}
      <TableCell>
        <div>
          <Typography style={styles.typoghrphyStyle}>
            {grandTotal?.nationalChiefCount ?? "NA"}
          </Typography>{" "}
        </div>
      </TableCell>
      <TableCell>
        <div>
          <Typography style={styles.typoghrphyStyle}>
            {grandTotal?.nationalDeputyChiefCount ?? "NA"}
          </Typography>{" "}
        </div>
      </TableCell>
      <TableCell>
        <div>
          <Typography style={styles.typoghrphyStyle}>
            {grandTotal?.nationalAdvisorCount ?? "NA"}
          </Typography>{" "}
        </div>
      </TableCell>
      <TableCell>
        <div>
          <Typography style={styles.typoghrphyStyle}>
            {grandTotal?.areaChiefCount ?? "NA"}
          </Typography>{" "}
        </div>
      </TableCell>
      <TableCell>
        <div>
          <Typography style={styles.typoghrphyStyle}>
            {grandTotal?.areaDeputyChiefCount ?? "NA"}
          </Typography>{" "}
        </div>
      </TableCell>
      <TableCell>
        <div>
          <Typography style={styles.typoghrphyStyle}>
            {grandTotal?.areaAdvisorCount ?? "NA"}
          </Typography>{" "}
        </div>
      </TableCell>
      <TableCell>
        <div>
          <Typography style={styles.typoghrphyStyle}>
            {grandTotal?.areaViceChiefCount ?? "NA"}
          </Typography>{" "}
        </div>
      </TableCell>
      <TableCell>
        <div>
          <Typography style={styles.typoghrphyStyle}>
            {grandTotal?.zoneChiefCount ?? "NA"}
          </Typography>{" "}
        </div>
      </TableCell>
      <TableCell>
        <div>
          <Typography style={styles.typoghrphyStyle}>
            {grandTotal?.zoneDeputyChiefCount ?? "NA"}
          </Typography>{" "}
        </div>
      </TableCell>
      <TableCell>
        <div>
          <Typography style={styles.typoghrphyStyle}>
            {grandTotal?.zoneAdvisorCount ?? "NA"}
          </Typography>{" "}
        </div>
      </TableCell>
      <TableCell>
        <div>
          <Typography style={styles.typoghrphyStyle}>
            {grandTotal?.zoneViceChiefCount ?? "NA"}
          </Typography>{" "}
        </div>
      </TableCell>
      <TableCell>
        <div>
          <Typography style={styles.typoghrphyStyle}>
            {grandTotal?.regionChiefCount ?? "NA"}
          </Typography>{" "}
        </div>
      </TableCell>
      <TableCell>
        <div>
          <Typography style={styles.typoghrphyStyle}>
            {grandTotal?.regionDeputyChiefCount ?? "NA"}
          </Typography>{" "}
        </div>
      </TableCell>
      <TableCell>
        <div>
          <Typography style={styles.typoghrphyStyle}>
            {grandTotal?.regionAdvisorCount ?? "NA"}
          </Typography>{" "}
        </div>
      </TableCell>
      <TableCell>
        <div>
          <Typography style={styles.typoghrphyStyle}>
            {grandTotal?.regionViceChiefCount ?? "NA"}
          </Typography>{" "}
        </div>
      </TableCell>
      <TableCell>
        <div>
          <Typography style={styles.typoghrphyStyle}>
            {grandTotal?.chapterChiefCount ?? "NA"}
          </Typography>{" "}
        </div>
      </TableCell>
      <TableCell>
        <div>
          <Typography style={styles.typoghrphyStyle}>
            {grandTotal?.chapterDeputyChiefCount ?? "NA"}
          </Typography>{" "}
        </div>
      </TableCell>
      <TableCell>
        <div>
          <Typography style={styles.typoghrphyStyle}>
            {grandTotal?.chapterAdvisorCount ?? "NA"}
          </Typography>{" "}
        </div>
      </TableCell>
      <TableCell>
        <div>
          <Typography style={styles.typoghrphyStyle}>
            {grandTotal?.chapterViceChiefCount ?? "NA"}
          </Typography>{" "}
        </div>
      </TableCell>
      <TableCell>
        <div>
          <Typography style={styles.typoghrphyStyle}>
            {grandTotal?.districtChiefCount ?? "NA"}
          </Typography>{" "}
        </div>
      </TableCell>
      <TableCell>
        <div>
          <Typography style={styles.typoghrphyStyle}>
            {grandTotal?.districtDeputyChiefCount ?? "NA"}
          </Typography>{" "}
        </div>
      </TableCell>
      <TableCell>
        <div>
          <Typography style={styles.typoghrphyStyle}>
            {grandTotal?.districtAdvisorCount ?? "NA"}
          </Typography>{" "}
        </div>
      </TableCell>
      <TableCell>
        <div>
          <Typography style={styles.typoghrphyStyle}>
            {grandTotal?.districtViceChiefCount ?? "NA"}
          </Typography>{" "}
        </div>
      </TableCell>
      <TableCell>
        <div>
          <Typography style={styles.typoghrphyStyle}>
            {grandTotal?.blockChiefCount ?? "NA"}
          </Typography>{" "}
        </div>
      </TableCell>
      <TableCell>
        <div>
          <Typography style={styles.typoghrphyStyle}>
            {grandTotal?.blockDeputyChiefCount ?? "NA"}
          </Typography>{" "}
        </div>
      </TableCell>
      <TableCell>
        <div>
          <Typography style={styles.typoghrphyStyle}>
            {grandTotal?.blockAdvisorCount ?? "NA"}
          </Typography>{" "}
        </div>
      </TableCell>
      <TableCell>
        <div>
          <Typography style={styles.typoghrphyStyle}>
            {grandTotal?.blockViceChiefCount ?? "NA"}
          </Typography>{" "}
        </div>
      </TableCell>
      <TableCell>
        <div>
          <Typography style={styles.typoghrphyStyle}>
            {grandTotal?.totalLeaderCount ?? "NA"}
          </Typography>{" "}
        </div>
      </TableCell>
    </TableRow>
  );

  return rows;
};

function ReportTable({ searchData, currentPage, pageSize }) {
  const hierarchyLevel = searchData[0]?.hierarchy;

  const REPORT_TABLE_COL = [
    {
      displayName: "S.NO",
      key: "s.no",
    },
    {
      displayName: "",
      key: "hierarchyLevel",
    },
    {
      displayName: "GOHONZON",
      key: "gohonzon",
    },
    {
      displayName: "MD",
      key: "md",
    },
    {
      displayName: "WD",
      key: "wd",
    },
    {
      displayName: "YMD",
      key: "ymd",
    },
    {
      displayName: "YWD",
      key: "ywd",
    },
    {
      displayName: "YMDSD",
      key: "ymdsd",
    },
    {
      displayName: "YWDSD",
      key: "ywdsd",
    },
    {
      displayName: "FDBCB",
      key: "fdbcb",
    },
    {
      displayName: "FDBYLB",
      key: "fdbylb",
    },
    {
      displayName: "FDBYPB",
      key: "fdbypb",
    },
    {
      displayName: "FDGCG",
      key: "fdgcg",
    },
    {
      displayName: "FDGYLG",
      key: "fdgylg",
    },
    {
      displayName: "FDGYPG",
      key: "fdgypg",
    },
    // OLD (bug): These were extra duplicate columns. CSV has only YMDSD/YWDSD.
    // {
    //   displayName: "YmdSdCount",
    //   key: "ymdsdcount",
    // },
    // {
    //   displayName: "YwdSdCount",
    //   key: "ywdsdcount",
    // },
    {
      displayName: "TOTAL MEMBER",
      key: "totalMember",
    },
    {
      displayName: "Friend MD",
      key: "fmd",
    },
    {
      displayName: "Friend WD",
      key: "fwd",
    },
    {
      displayName: "Friend YMD",
      key: "fymd",
    },
    {
      displayName: "Friend YWD",
      key: "fywd",
    },
    {
      displayName: "Friend YMDSD",
      key: "fymdsd",
    },
    {
      displayName: "Friend YWDSD",
      key: "fywdsd",
    },
    {
      displayName: "Friend FDBCB",
      key: "ffdbcb",
    },
    {
      displayName: "Friend FDBYPB",
      key: "ffdbypb",
    },
    {
      displayName: "Friend FDBYLB",
      key: "ffdbylb",
    },
    {
      displayName: "Friend FDGCG",
      key: "ffdgcg",
    },
    {
      displayName: "Friend FDYPG",
      key: "ffdypg",
    },
    {
      displayName: "Friend FDGYLG",
      key: "ffdgylg",
    },
    {
      displayName: "TOTAL FRIEND",
      key: "totalFriend",
    },
    //  {
    //     displayName: "AREA",
    //     key: "area",
    //   },
    // hierarchyLevel !== BLOCK &&
    //   hierarchyLevel !== DISTRICT &&
    //   hierarchyLevel !== CHAPTER &&
    //   hierarchyLevel !== REGION &&
    //   hierarchyLevel !== ZONE && {
    //     displayName: "ZONE",
    //     key: "zone",
    //   },
    // hierarchyLevel !== BLOCK &&
    //   hierarchyLevel !== DISTRICT &&
    //   hierarchyLevel !== CHAPTER &&
    //   hierarchyLevel !== REGION && {
    //     displayName: "REGION",
    //     key: "region",
    //   },
    // hierarchyLevel !== BLOCK &&
    //   hierarchyLevel !== DISTRICT &&
    //   hierarchyLevel !== CHAPTER && {
    //     displayName: "CHAPTER",
    //     key: "chapter",
    //   },
    // hierarchyLevel !== BLOCK &&
    //   hierarchyLevel !== DISTRICT && {
    //     displayName: "DISTRICT",
    //     key: "district",
    //   },
    // hierarchyLevel !== BLOCK && {
    //   displayName: "BLOCK",
    //   key: "block",
    // },
    {
      displayName: "NC",
      key: "nc",
    },
    {
      displayName: "DNC",
      key: "dnc",
    },
    {
      displayName: "NA",
      key: "na",
    },
    {
      displayName: "AC",
      key: "ac",
    },
    {
      displayName: "DAC",
      key: "dac",
    },
    {
      displayName: "AA",
      key: "aa",
    },
    {
      displayName: "VAC",
      key: "vac",
    },
    {
      displayName: "ZC",
      key: "zc",
    },
    {
      displayName: "DZC",
      key: "dzc",
    },
    {
      displayName: "ZA",
      key: "za",
    },
    {
      displayName: "VZC",
      key: "vzc",
    },
    {
      displayName: "RC",
      key: "rc",
    },
    {
      displayName: "DRC",
      key: "drc",
    },
    {
      displayName: "RA",
      key: "ra",
    },
    {
      displayName: "VRC",
      key: "vrc",
    },
    {
      displayName: "CC",
      key: "cc",
    },
    {
      displayName: "DCC",
      key: "dcc",
    },
    {
      displayName: "CA",
      key: "ca",
    },
    {
      displayName: "VCC",
      key: "vcc",
    },
    {
      displayName: "DC",
      key: "dc",
    },
    {
      displayName: "DDC",
      key: "ddc",
    },
    {
      displayName: "DA",
      key: "da",
    },
    {
      displayName: "VDC",
      key: "vdc",
    },
    {
      displayName: "BC",
      key: "bc",
    },
    {
      displayName: "DBC",
      key: "dbc",
    },
    {
      displayName: "BA",
      key: "ba",
    },
    {
      displayName: "VBC",
      key: "vbc",
    },
    {
      displayName: "TOTAL LEADER",
      key: "leaderTotal",
    },
  ];
  const updatedColumns = React.useMemo(() => {
    return REPORT_TABLE_COL.filter(
      (col) => col.displayName || col.displayName === ""
    ).map((col) => {
      if (col.key === "hierarchyLevel") {
        return {
          ...col,
          displayName: `${hierarchyLevel}'s`,
        };
      }
      return col;
    });
  }, [hierarchyLevel]);

  return (
    <div style={styles.container}>
      <Table
        scrollable
        columns={updatedColumns}
        rows={getRows({
          searchData,
          currentPage,
          pageSize,
        })}
        tableHeadCellStyle={{
          ...styles.tableHeadCells,
          textAlign: "left",
        }}
        searchData={searchData}
      />
    </div>
  );
}

export default ReportTable;
